'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _ContentCardPaywall = require('./ContentCardPaywall');

var _ContentCardPaywall2 = _interopRequireDefault(_ContentCardPaywall);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ContentCardPaywall2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/ContentCardPaywall/index.js
// module id = 263
// module chunks = 11